"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMO_SENDER_RANDOM_NULL = exports.UnshieldFlag = exports.TOKEN_SUB_ID_NULL = void 0;
exports.TOKEN_SUB_ID_NULL = '0x00';
exports.UnshieldFlag = {
    NO_UNSHIELD: BigInt(0),
    UNSHIELD: BigInt(1),
    OVERRIDE: BigInt(2),
};
// 15 bytes: 00
exports.MEMO_SENDER_RANDOM_NULL = '000000000000000000000000000000';
